import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01e0207d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold m-lazy-media lazy-iframe" }
const _hoisted_2 = ["src"]

import { onMounted, ref } from 'vue';

interface ScribeIframeProps {
  src: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScribeIframe',
  props: {
    src: {}
  },
  setup(__props: any) {



const frame = ref<HTMLIFrameElement | null>(null);

/**
 * Function to resize the iframe to the height of the content
 * The height is sent from the iframe (via postMessage) when the content is ready
 * https://github.com/manifoldxyz/studio-app-rich-text-minting/blob/main/src/common/util.ts#L193
 */
const handleMessage = (event: MessageEvent) => {
  if (frame.value) {
    const { type, height } = event.data;
    if (type === 'resize' && typeof height === 'number') {
      frame.value.style.height = `${height}px`;
      frame.value.style.minHeight = `${height}px`;
    }
  }
};

onMounted(() => {
  window.addEventListener('message', handleMessage, false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      src: _ctx.src,
      ref_key: "frame",
      ref: frame,
      title: "listing-iframe",
      sandbox: "allow-same-origin allow-scripts allow-popups",
      allow: "camera; microphone; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    }, null, 8, _hoisted_2)
  ]))
}
}

})